export default {"src":"/_next/static/image/assets/Illustrations/linkedin 2.7be76f8ce2581a7515811fc245df39f2.svg","height":24,"width":24};